import { Placeholder } from './_Placeholder.js';

export function UtentiSection() {
  return <Placeholder title="Utenti" hint="CRUD utenti operatori con permessi" />;
}
